export default "__VITE_ASSET__N9W1Abb9__"